import DailyActivitiesTable from './daily-activities-table';

export default DailyActivitiesTable;
